export default {
    "Primary green": "themeClearGreen",
    "Fundamental green": "themeLightGreen",
    "Sustainable green": "themeDarkGreen",
    "Multi blue": "themeLightBlue",
    "Fixed blue": "themeDarkBlue",
    "Quantitative red": "themeDarkRed",
    "Trusted blue": "themeTrustedBlue",
    Main: "themeMain",
};
